import { jsx } from 'react/jsx-runtime';
import { SVG } from '../utils/style.svg.js';
import { getDefaultHeight } from '../utils/get-default-height.js';

const RoundedTopGraphic = ({
  color,
  ...svgProps
}) => {
  return /*#__PURE__*/jsx(SVG, {
    viewBox: "0 0 2600 99.6",
    xmlns: "http://www.w3.org/2000/svg",
    height: getDefaultHeight(svgProps, 99.6),
    ...svgProps,
    stroke: svgProps.stroke ?? "none",
    fill: color ?? svgProps.fill ?? "currentColor",
    children: /*#__PURE__*/jsx("path", {
      d: "M2557.6,80.7c-4.2-0.3-8.7-0.6-13.5-0.9c-2.9-0.2-5.8-0.4-8.9-0.6c-12.8-0.8-27.3-1.7-43.4-2.7c-4-0.2-8-0.5-12.2-0.7 c-12.4-0.7-25.7-1.5-39.8-2.4c-2.7-0.2-5.3-0.3-8.1-0.5c-109-6.3-264.1-14.4-444.3-21.2c-23-0.9-46.4-1.7-70.2-2.6 c-30.2-1.1-60.9-2.1-92.2-3c-47.4-1.4-95.9-2.8-145.3-3.9c-23.3-0.5-46.7-1-70.4-1.5c-103.8-2-210.5-3.2-317.4-3.2 c-11.9,0-23.7,0-35.6,0c-38.4,0.1-76.6,0.3-114.6,0.7c-49.2,0.5-97.9,1.2-146,2.1c-11.2,0.2-22.4,0.4-33.5,0.7 c-40.7,0.8-80.8,1.8-120.2,2.8c-28.9,0.8-57.4,1.6-85.5,2.5c-22.9,0.7-45.6,1.5-67.9,2.2c-85.4,2.9-166,6.2-240,9.6 c-0.8,0-1.6,0.1-2.4,0.1c-44,2-85.5,4-124.3,6c-14.5,0.7-28.7,1.5-42.4,2.2c-13,0.7-25.6,1.4-37.8,2.1c-0.1,0-0.2,0-0.3,0 c-90.2,5-159.3,9.4-200,12.1H0v2.8V100h2600V83.5v-2.8H2557.6z",
      clipRule: "evenodd",
      fillRule: "evenodd"
    })
  });
};

export { RoundedTopGraphic };
//# sourceMappingURL=rounded.top.js.map
